import { ApiError, useEloApi } from '@/api/api';
import { useError } from '@/contexts/ErrorContext';
import { Card, Loader, Stack, Text, Title } from '@mantine/core';
import { IconAlertCircleFilled, IconCircleCheck } from '@tabler/icons-react';
import { useCallback, useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

export const ActionsPage = () => {
  const { token } = useParams();
  if (!token) return null;

  const [searchParams, setSearchParams] = useSearchParams();

  const api = useEloApi({});
  const errorContext = useError();

  const [loading, setLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [message, setMessage] = useState('');

  const doAction = useCallback(async () => {
    if (!token) return null;
    setLoading(true);
    try {
      const entries = Array.from(searchParams.entries());
      const paramsObject = Object.fromEntries(entries);
      const res = await api.doAction(token, paramsObject);
      setMessage(res.message);
      setIsError(false);
    } catch (e) {
      console.error(e);
      setIsError(true);
      if (e instanceof ApiError) {
        setMessage(e.message);
      } else {
        setMessage('Unknown Error');
      }
    } finally {
      setLoading(false);
    }
  }, [searchParams, token]);

  useEffect(() => {
    if (!message) doAction();
  }, [message]);

  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        minHeight: '100dvh',
        backgroundColor: 'var(--mantine-background)',
      }}
    >
      {loading ? (
        <div style={{ margin: 'auto' }}>
          <Stack justify="center" align="center">
            <Loader></Loader>
            <Text className="loading-dots">{'Esperando respuesta'}</Text>
          </Stack>
        </div>
      ) : (
        <Card
          shadow="sm"
          padding="lg"
          radius="md"
          withBorder
          style={{
            margin: 'auto',
            position: 'relative',
            minWidth: '450px',
          }}
        >
          <Stack justify="center" align="center">
            {isError ? (
              <IconAlertCircleFilled size={128} color="var(--mantine-color-red-7)" />
            ) : (
              <IconCircleCheck size={128} color="var(--mantine-color-green-7)" />
            )}
            <Title order={2}>{isError ? 'ERROR' : 'SUCCESS'}</Title>
            <Text>{message}</Text>
          </Stack>
        </Card>
      )}
    </div>
  );
};
